import { render, staticRenderFns } from "./SystemRouterEdit.vue?vue&type=template&id=180854af&scoped=true&"
import script from "./SystemRouterEdit.vue?vue&type=script&lang=js&"
export * from "./SystemRouterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180854af",
  null
  
)

export default component.exports